import {
  Badge,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Popconfirm,
  Radio,
  Row,
  Select,
  Skeleton,
} from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../actions/products";
import { getUsers } from "../../actions/users";
import { useNavigate, useParams } from "react-router-dom";
import { orderStatus, paymentMethod } from "../../utils/Utils";
import {
  createOrder,
  deleteOrder,
  getOrder,
  updateOrder,
} from "../../actions/orders";
import { getStore } from "../../actions/store";
import Invoice from "./Invoice";

const Order = ({ currentUser, storeCurrency }) => {
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [billingAddressCheck, setBillingAddressCheck] = useState(true);
  const [, forceUpdate] = useState({});
  const [ship, setShip] = useState();
  const [quantity, setQuantity] = useState(1);
  const [checkPay, setCheckPay] = useState();
  const [orderItems, setOrderItems] = useState([]);
  const { id } = useParams();

  const countries = require("../../utils/countries.json");

  const userList = useSelector((state) => state?.users);
  const productList = useSelector((state) => state?.products);
  const shippingItems = useSelector((state) => state.store)?.store
    ?.shippingInfo;
  const order = useSelector((state) => state?.orders)?.order;
  const products = useSelector((state) => state?.orders)?.products;

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    forceUpdate({});
    dispatch(getProducts(currentUser.store));
    dispatch(getUsers(currentUser.store, "CUSTOMER"));
    dispatch(getStore(currentUser?.store));
    if (id) {
      dispatch(getOrder(id));
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const dispatch = useDispatch();
  const history = useNavigate();
  const { Option } = Select;
  const [form] = Form.useForm();

  const findShippingPrice = shippingItems?.filter((a) => a._id === ship)?.[0]
    ?.value;

  const getCartSubTotal = () => {
    if (id) {
      return products
        ?.reduce(
          (price, item) => price + item.product.price * item.quantity,
          0 + ship
        )
        ?.toFixed(2);
    } else {
      return orderItems
        ?.reduce(
          (price, item) => price + item.product.price * item.quantity,
          0 + findShippingPrice
        )
        ?.toFixed(2);
    }
  };

  const getTotal = () => {
    if (id) {
      return products
        ?.reduce((price, item) => price + item.product.price * item.quantity, 0)
        ?.toFixed(2);
    } else {
      return orderItems
        ?.reduce((price, item) => price + item.product.price * item.quantity, 0)
        ?.toFixed(2);
    }
  };

  const onFinish = (value) => {
    const billingAddress = form.getFieldValue("billingAddress");
    const shippingAddress = form.getFieldValue("shippingAddress");
    const billingAddressCity = form.getFieldValue("billingAddressCity");
    const shippingAddressCity = form.getFieldValue("shippingAddressCity");
    const billingAddressState = form.getFieldValue("billingAddressState");
    const shippingAddressState = form.getFieldValue("shippingAddressState");
    const billingAddressCountry = form.getFieldValue("billingAddressCountry");
    const shippingAddressCountry = form.getFieldValue("shippingAddressCountry");
    const billingAddressZip = form.getFieldValue("billingAddressZip");
    const shippingAddressZip = form.getFieldValue("shippingAddressZip");
    const formData = {
      ...value,
      billingAddress: billingAddress ? billingAddress : shippingAddress,

      billingAddressCity: billingAddressCity
        ? billingAddressCity
        : shippingAddressCity,

      billingAddressState: billingAddressState
        ? billingAddressState
        : shippingAddressState,

      billingAddressCountry: billingAddressCountry
        ? billingAddressCountry
        : shippingAddressCountry,

      billingAddressZip: billingAddressZip
        ? billingAddressZip
        : shippingAddressZip,

      store: currentUser.store,
      paymentMethod: checkPay,
      orderItems,
    };
    setLoadingButton(true);
    if (id) {
      dispatch(updateOrder(id, formData, history, setLoadingButton));
    } else {
      dispatch(createOrder(formData, history, setLoadingButton));
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      billingAddress: order?.billingAddress,
      shippingAddress: order?.shippingAddress,
      billingAddressCity: order?.billingAddressCity,
      shippingAddressCity: order?.shippingAddressCity,
      billingAddressState: order?.billingAddressState,
      shippingAddressState: order?.shippingAddressState,
      billingAddressCountry: order?.billingAddressCountry,
      shippingAddressCountry: order?.shippingAddressCountry,
      billingAddressZip: order?.billingAddressZip,
      shippingAddressZip: order?.shippingAddressZip,
      phone: order?.phone,
      user: order?.user?._id,
      status: order?.status,
      paymentMethod: order?.paymentMethod,
      shippingMethod: order?.shippingMethod?._id,
    });
    setShip(order?.shippingMethod?.value);
  }, [order]);

  const deleteOrderFun = () => {
    dispatch(deleteOrder(id, history));
  };

  return (
    <Dashboard title={`${id ? "View" : "Add"} Order`}>
      <div className="p-4 shadow bg-white mt-2 mb-6 flex items-center justify-between">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/orders">Orders</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{`${id ? "View" : "Add"} Order`}</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        form={form}
        autoComplete="off"
      >
        <div className="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div className="mt-5 md:mt-0 md:col-span-2 px-4 py-5 sm:p-6 bg-white shadow">
            <Skeleton loading={loading}>
              <Row gutter={16}>
                <h4 className="mb-4">Shipping Address Details</h4>
                <Col span={24}>
                  <Form.Item
                    label="Address"
                    name="shippingAddress"
                    rules={[
                      { required: true, message: "Please input address!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="City"
                    name="shippingAddressCity"
                    rules={[{ required: true, message: "Please input city!" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="State"
                    name="shippingAddressState"
                    rules={[{ required: true, message: "Please input city!" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Country"
                    name="shippingAddressCountry"
                    rules={[
                      { required: true, message: "Please select country!" },
                    ]}
                  >
                    <Select
                      required
                      style={{ width: "100%" }}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {countries?.length > 0
                        ? countries?.map((country) => (
                            <Option key={country?.code} value={country?.name}>
                              {country?.name}
                            </Option>
                          ))
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Zip"
                    name="shippingAddressZip"
                    rules={[{ required: true, message: "Please input zip!" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24} className="mb-4">
                  <Checkbox
                    checked={billingAddressCheck}
                    onChange={(e) => setBillingAddressCheck(e.target.checked)}
                  >
                    Billing address same as Shipping address
                  </Checkbox>
                </Col>
                {!billingAddressCheck ? (
                  <>
                    <h4 className="my-4">Billing Address Details</h4>
                    <Col span={24}>
                      <Form.Item label="Address" name="billingAddress">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="City" name="billingAddressCity">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="State" name="billingAddressState">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Country" name="billingAddressCountry">
                        <Select
                          required
                          style={{ width: "100%" }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {countries?.length > 0
                            ? countries?.map((country) => (
                                <Option
                                  key={country?.code}
                                  value={country?.name}
                                >
                                  {country?.name}
                                </Option>
                              ))
                            : ""}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Zip" name="billingAddressZip">
                        <Input />
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  ""
                )}
                <Col span={12}>
                  <Form.Item
                    label="Contact"
                    name="phone"
                    rules={[{ required: true, message: "Please input phone!" }]}
                  >
                    <Input type="number" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Shipping Method"
                    name="shippingMethod"
                    rules={[
                      {
                        required: true,
                        message: "Please select shipping!",
                      },
                    ]}
                  >
                    {shippingItems?.length > 0 ? (
                      <Radio.Group
                        onChange={(e) => setShip(e.target.value)}
                        disabled={id}
                      >
                        {shippingItems?.map((shipping) => (
                          <Radio
                            key={shipping?._id}
                            value={shipping?._id}
                            style={{ marginTop: 5, marginBottom: 5 }}
                          >
                            {shipping?.name} {shipping?.description} (
                            {storeCurrency} {shipping?.value})
                          </Radio>
                        ))}
                      </Radio.Group>
                    ) : (
                      "This Store doesn't have any shipping method."
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Skeleton>
          </div>
          <div className="md:col-span-1">
            <div className="bg-white shadow px-4 py-5 sm:p-6">
              <Skeleton loading={loading}>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      label="Choose Products"
                      name="orderItems"
                      className="pro"
                    >
                      {id ? (
                        <div className="max-h-40 overflow-auto mb-6">
                          {products?.length > 0
                            ? products?.map((o, index) => (
                                <div
                                  key={index}
                                  className="flex items-center justify-between p-2 border"
                                >
                                  <div>{o?.product?.name}</div>
                                  <div>
                                    {storeCurrency}
                                    {o?.product?.price}
                                  </div>
                                </div>
                              ))
                            : ""}
                        </div>
                      ) : (
                        <div className="max-h-40 overflow-auto">
                          {productList?.length > 0
                            ? productList?.map((product) => (
                                <Checkbox
                                  key={product?._id}
                                  value={{ product, quantity }}
                                  onChange={() =>
                                    setOrderItems([{ product, quantity }])
                                  }
                                >
                                  <p className="m-0 truncate max-w-48">
                                    {product?.name}
                                  </p>
                                  {/* <select
                                  className="border rounded px-6"
                                  value={quantity}
                                  onChange={(e) => setQuantity(e.target.value)}
                                >
                                  {[...Array(product.countInStock).keys()].map(
                                    (x) => (
                                      <option key={x + 0} value={x + 0}>
                                        {x + 0}
                                      </option>
                                    )
                                  )}
                                </select> */}
                                  <p>
                                    {storeCurrency}
                                    {product?.price}
                                  </p>
                                </Checkbox>
                              ))
                            : ""}
                        </div>
                      )}
                      <li className="uppercase">
                        <span className="text-black">Subtotal</span>
                        <span>
                          {storeCurrency}
                          {getTotal()}
                        </span>
                      </li>
                      <li className="uppercase">
                        <span className="text-black">Shipping</span>
                        <span>
                          Flat rate: {storeCurrency}{" "}
                          {id ? ship : findShippingPrice}
                        </span>
                      </li>
                      <li className="uppercase">
                        <span className="text-black">Total</span>
                        <span>
                          {storeCurrency}
                          {getCartSubTotal()}
                        </span>
                      </li>
                    </Form.Item>
                    <Form.Item
                      name="paymentMethod"
                      rules={[
                        {
                          required: true,
                          message: "Please select shipping!",
                        },
                      ]}
                    >
                      <Radio.Group
                        onChange={(e) => setCheckPay(e?.target?.value)}
                        disabled={id}
                      >
                        {paymentMethod?.length > 0
                          ? paymentMethod?.map((pay) => (
                              <Radio
                                key={pay?.id}
                                value={pay?.value}
                                style={{ marginTop: 5, marginBottom: 5 }}
                              >
                                {pay?.value}
                              </Radio>
                            ))
                          : ""}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="User" name="user">
                      <Select
                        style={{ width: "100%" }}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        disabled={id}
                      >
                        {userList?.length > 0
                          ? userList?.map((user) => (
                              <Option key={user?._id} value={user?._id}>
                                {user?.name}
                              </Option>
                            ))
                          : ""}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Status" name="status">
                      <Select
                        style={{ width: "100%" }}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {orderStatus?.length > 0
                          ? orderStatus?.map((status) => (
                              <Option key={status?.id} value={status?.value}>
                                <Badge status={status?.color} />
                                <span className="px-1">{status?.value}</span>
                              </Option>
                            ))
                          : ""}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <div className="flex flex-wrap  justify-start gap-4">
                      <Button href="/orders">Cancel</Button>
                      <Form.Item shouldUpdate style={{ marginBottom: 0 }}>
                        {() => (
                          <Button
                            type="primary"
                            htmlType="submit"
                            disabled={
                              (!id && !form.isFieldsTouched(true)) ||
                              !!form
                                .getFieldsError()
                                .filter(({ errors }) => errors.length).length
                            }
                            loading={loadingButton}
                          >
                            {`${id ? "Update" : "Save"} Order`}
                          </Button>
                        )}
                      </Form.Item>
                      {id ? (
                        <>
                          <Popconfirm
                            title="Are you sure to delete this order?"
                            onConfirm={deleteOrderFun}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button danger type="primary">
                              Delete
                            </Button>
                          </Popconfirm>
                          <Invoice
                            storeCurrency={storeCurrency}
                            order={order}
                            ship={ship}
                          />{" "}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
              </Skeleton>
            </div>
          </div>
        </div>
      </Form>
    </Dashboard>
  );
};

export default Order;
